import React, { useState, useEffect, useRef } from 'react';

import styles from './styles.module.scss';

import { useContext } from 'react';

import 'moment/locale/fa';

import Cookies from 'js-cookie';
import Api from '../../api';
import Loader from '../Loader';
import InfiniteScroll from 'react-infinite-scroll-component';
import SHARED from '../../constants';
import AppIcons from '../../icons';

import FileTypeComponent from '../FileTypeComponent';
import FileTypesContainer from '../FileTypesContainer';
import { AdminContext } from '../../context/AdminContext';
import SingleMessage from '../SingleMessage';
import MessageTypes from '../ActiveChatInfo/MessageTypes';
import Avatar from '../Avatar';
import FileUploadVideo from '../FileUploadVideo';
import { CancelToken } from 'axios';
import UploadingVideoModal from '../UploadingVideoModal';
import blanckUser from '../../../../assets/imgs/blank-profile-picture.png';
// import FileUpload from '../FileUpload';
// import FileUploadVideo from '../FileUploadVideo';
// import { AppContext } from '../../context/VideoCutContext';

const UserDashboard = ({
  content,
  extraScrollDivStyle,
  extraScrollDivStyleInside,
}) => {
  const [serverError, setServerError] = useState('');

  const [loading, setLoading] = useState(true);
  const [files, setFiles] = useState([]);
  const [hasMore, setHasMore] = useState(false);
  const [count, setCount] = useState(0);

  const [activePlayer, setActivePlayer] = useState();
  const {
    activeMessage,
    setActiveMessage,
    activeUser,
    setActiveAudio,
    activeMenuFile,
    themeMode,
    userChannelId, privateUsers,setShowFirstMessage,setUserChannelId,    previousChannelId,
    setPreviousChannelId, setActiveUser,    sharedUserClicked,
    setSharedUserClicked,     setSharedUser, setTrigger, userInfo,
    updateAppState,
    setNotificationText,
    modalInputValue,
    setModalInputValue,
    // setopenNotificationModalError,
    themeColor,
    musicExtension,
    videoType,
    videoSize,
    setVideoUploaded,
    videoUploaded,
    setVideoType,
    setVideoSize,
  } = useContext(AdminContext);


  // const [videoType,setVideoType]= useState(['mp4'])
  const uploadRef = React.useRef(null);
console.log("videotype", videoType, videoSize)
const cancelFileUpload = useRef(null);
  const [activeMenu, setActiveMenu] = useState(2);
  const [menus,setMenus]= useState(content?.userDashboard);
  const [selectedFile,setSelectedFile]=useState(null)

console.log("uuuuuuuuuuu", content)
  // const { updateAppState } = useContext(AppContext);

  const [conditions, setConditions] = useState();

  const [progressValue, setProgressValue] = useState(0);
  const [ifMusic, setIfMusic] = useState(false);
  const emptyUploadResponse={
    fileId: '',
    cover: {
      filename_1: '',
      filename_2: '',
      filename_3: '',
      filename_4: '',
    },
    token: '',
    name: '',
    nameThumbnail: '',
  }
  const [uploadResponse, setUploadResponse] = useState(emptyUploadResponse);

  // drag state
  const [dragActive, setDragActive] = useState(false);
  const [loadingCrop, setloadingCrop] = useState(false);
  const [cookieValue, setCookieValue] = useState();
  // ref
  const inputRef = React.useRef(null);
  // const [videoInformation, setVideoInformation] = useState({
  //   name: '',
  //   image_id: '',
  //   age_class_id: 1,
  //   token: '',
  //   playlist_ids: [],
  //   privateUserContent: '',
  //   category_id: '',
  //   content: '',
  //   file_id: '',
  //   file_srt_id: '',
  //   userIds: [],
  //   child_content: 0,
  //   comment_status_id: '1',
  //   status_id: '',
  //   user_status_id: '1',
  //   watermark: 0,
  //   channelId: Cookies.get('userAuthClipsho'),
  //   keywords: [],
  // });
  const emptyVideo={
    videoId: null,
    priceType: "",
    name: {
      required: true,
      value: '',
      errorTitle: null,
      helpBox: false,
    },
    category: "",
    content: {
      required: true,
      value: '',
      errorTitle: null,
      helpBox: false,
    },
    keywords: {
      required: true,
      value: [],
      errorTitle: null,
      helpBox: false,
    },

    channel: {
      required: true,
      value:
        typeof window !== 'undefined' && typeof document !== 'undefined'
          ? Cookies.get('userAuthClipsho')
          : undefined,
      errorTitle: null,
      helpBox: false,
      price: 0,
      priceType: false,
    },
    playlists: {
      required: true,
      value: [],
      errorTitle: null,
      helpBox: false,
    },
    comment: {
      required: true,
      value: 1,
      errorTitle: null,
      helpBox: false,
    },
    age: {
      required: true,
      value: 1,
      errorTitle: null,
      helpBox: false,
    },
    file: {
      required: true,
      value: '',
      token: '',
      serverId: '',
      size: '',
      name: '',
      errorTitle: null,
      helpBox: false,
    },
    image: {
      required: true,
      value: '',
      name: '',
      errorTitle: null,
      helpBox: false,
    },
    image_id: '',
    age_class_id: 1,
    token: '',
    playlist_ids: [],
    privateUserContent: '',

    file_id: '',
    file_srt_id: '',
    userIds: [],
    child_content: 0,
    comment_status_id: '1',
    status_id: '',
    user_status_id: '1',
    watermark: 0,
    typeId: '',
    musicName: '',
  }
  const [videoInformation, setVideoInformation] = useState(emptyVideo);
  const emptyUploadedImage={
    status: '',
    message: '',

    response: {
      fileId: '',
      cover: {
        filename_1: '',
        filename_2: '',
        filename_3: '',
        filename_4: '',
        filename_5: '',
      },
      token: '',
      name: '',
      nameThumbnail: '',
      serverId: '',
    },
  }
  const [uploadedImage, setUploadedImage] = useState(emptyUploadedImage);
  const [videoForm, setVideoForm] = useState(null);
  // const uploadRef = React.useRef(null);

  console.log("activeMenu", activeMenu)

  useEffect(() => {
    setVideoForm(uploadRef);
    setLoading(true);
    getSignInfo();
    findList(0, 15);

  }, []);

  useEffect(() => {
    if(activeMenu !=1){
      closeModal();
    setLoading(true);
    findList(0, 15);
    }


    setVideoUploaded(false);
    return ()=>{closeModal()}
  }, [activeMenu]);
  const closeModal = () => {

    videoForm?.current?.reset();
    console.log("refffffff",inputRef?.current)
    if(inputRef.current != null ){
      // alert("1")
      inputRef.current.value=null;
      document.getElementById(`label-file-upload`).value = '';
    };
    // setModalInputValue({});
    setUploadedImage(emptyUploadedImage);
    setVideoInformation(emptyVideo);
    setUploadResponse(emptyUploadResponse);
    setVideoUploaded(false);

    if (cancelFileUpload.current) {
      cancelFileUpload.current('user has canceled upload');
    }
  };
  const findList = (start = 0, limit = 15, infinite = false) => {
    const activeType = content?.folderPart?.menu?.filter(
      (x) => x.id == activeMenu
    )?.[0]?.fileType;
    if (!infinite) {
      setLoading(true);
    }
    Api.userVideo({
      params: {
        fileType: activeType,
        start: start,
        limit: limit,
        // uuidUser: uuidUser,
      },
    })
      .then((res) => {
        callbackFunction(res, infinite);
      })
      .catch((err) => {
        setLoading(false);
      });

  };

  const getMorePosts = () => {

    findList(files?.length, 10, true);

  };

  const callbackFunction = (res, infinite = false) => {
    let newarray=[]
    if (infinite) {
    
      let newarrayResponse=[
        ...res.data.response.map((v) => ({
          ...v,
          file: {fileExtension:{type:'video'},...v?.fileVideo} ,
        })),
      ]
        newarray = [...files.concat(newarrayResponse)];
      
      setFiles(newarray);
    } else {
    //  newarray=res.data.response
         newarray= [
          ...res.data.response.map((v) => ({
            ...v,
            file: {fileExtension:{type:'video'},...v?.fileVideo} ,
          })),
        ]

      setFiles(
          newarray
        );
    }
    setLoading(false);
    setCount(res?.data?.response_details?.count);
  };
  useEffect(() => {
    setHasMore(files.length < count);

    if (files.length == 0) {
      setHasMore(false);
    }
  }, [files, count]);
  const activePlayerFunction = (playerId) => {
    // alert('hi');
    console.log('playerId', playerId, activePlayer);
    if (activePlayer) {
      activePlayer.pause(); // Pause previous active player
    }
    setActivePlayer(playerId);
  };
  useEffect(() => {
    console.log('activePlayer', activePlayer);
    if (activePlayer) {
      activePlayer.play();
    }
  }, [activePlayer]);

  useEffect(() => {
  }, [activeUser, activeMenu]);

  const getSignInfo=()=>{
    Api.layoutUserApis()
    .then((res) => {
      console.log("responseis==", res)
      setVideoType(res.data.response.videoExtension);
      setVideoSize(res.data.response.sizeVideo);
      // setVideoChatSize(res.data.response.sizeVideoChat);
      // setImageType(res.data.response.imageExtension);
      // setImageSize(res.data.response.sizeImage);
      // let correctType = '';
      // res?.data?.response.imageExtension?.map((item, index) => {
      //   correctType = item?.mime_type + ',' + correctType;
      // });
      // setCorrectTypeImage(correctType);
      // setSrtType(res.data.response.srtExtension);
      // setSrtSize(res.data.response.sizeSrt);
      // let correctTypeS = '';
      // res?.data?.response.srtExtension?.map((item, index) => {
      //   correctTypeS = item?.mime_type + ',' + correctTypeS;
      // });
      // setCorrectTypeSrt('.srt');
      // setFavoriteChannelsContex(res.data.response.memberList.response);
      // setUserInfo(res.data.response.profile);
      // setUserCategery({
      //   required: true,
      //   value: res.data.response.profile?.categoryId,
      //   errorTitle: null,
      //   helpBox: false,
      // });
      // setNotificationCount(res?.data?.response?.countNotification);
      // let correctTypeMusic = '';
      // res.data.response.videoExtension
      //   ?.filter((x) => x.type == 'music')
      //   ?.map((item, index) => {
      //     correctTypeMusic = item?.mime_type + ',' + correctTypeMusic;
      //   });
      // setMusicExtension(
      //   res.data.response.videoExtension?.filter((x) => x.type == 'music')
      // );
      // setCorrectMusicType(correctTypeMusic);

    })
    .catch((err) => {});
  }

  console.log('files', files, count, hasMore, content?.folderPart?.menu);
  console.log("activeMenu", activeMenu)
  const handleCloseUpload = () => {
    videoForm?.current?.reset();

    setVideoUploaded(false);
    if (cancelFileUpload.current) {
      cancelFileUpload.current('user has canceled upload');
    }
    // setUploadLevel(1);
    // setModalInputValue({});
    // setTrigger('');
    setVideoInformation(emptyVideo)
  };
  const handleCloseEditUpload = () => {
    videoForm?.current?.reset();

    setVideoUploaded(false);
    if (cancelFileUpload.current) {
      cancelFileUpload.current('user has canceled upload');
    }
    setVideoInformation(emptyVideo)

    // setTrigger('');
    // setUploadLevel(1);
  };
    // triggers when file is selected with click
    const handleChange = function (e) {
      // setopenNotificationModalError(false);
      console.log("eeeeeeee", e)
      if(e.target.files[0]){
      const allowedType = videoType?.findIndex(
        (x) => x.mimeType == e.target.files[0].type
      );
  
      console.log("allowed", allowedType, videoType)
      e.preventDefault();
      if (allowedType != -1 && e.target.files[0].size < videoSize) {
        e.stopPropagation();
        setDragActive(false);
        if (e.target.files && e.target.files[0]) {
          handleFile(e.target.files[0]);
        }
      } else {
        let correctType = '';
        videoType.map((item, index) => {
          correctType = correctType + ',' + item.name;
        });
  
        // setopenNotificationModalError(true);
        // setNotificationText({
        //   title: 'خطا در آپلود ویدیو',
        //   description: `نوع فایل مجاز : ${correctType} است. حجم مجاز فایل : ${
        //     videoSize / (1024 * 1024)
        //   } مگابایت است`,
        // });
      }
    }
    };
  
    // triggers the input when the button is clicked
    const onButtonClick = () => {
      // closeModal();
      // if(videoInformation?.file){
      //   closeModal();
      // }
      if(progressValue!=0 || videoUploaded){
        closeModal();

      }

      inputRef.current.click();
    };
    function handleFile(files) {
      console.log('fileeeee', files);
      // console.log(videoInformation);
      handleChangeInformation('file', {
        ...videoInformation.file,
        size: files.size,
        type: files.type,
      });
      // const allowedTypeMusic = musicExtension?.findIndex(
      //   (x) => x.mimeType == files?.type
      // );
      // if (allowedTypeMusic != -1) {
      //   setIfMusic(true);
      // }
      const formData = new FormData();
      formData.append('file', files);
  
      const config = {
        onUploadProgress: (progressEvent) => {
          setProgressValue(progressEvent.loaded);
          setVideoUploaded(true);
        },
        cancelToken: new CancelToken(
          (cancel) => (cancelFileUpload.current = cancel)
        ),
      };
      if (files) {
        updateAppState({
          current_step: 2,
          video_url: URL.createObjectURL(files),
        });
      }

      Api.videoUpload(formData, config)
        .then((res) => {
          handleChangeInformation('file', {
            ...videoInformation.file,
            value: res.data.response.fileId,
            token: res.data.response.token,
            serverId: res.data.response.serverId,
            name: res.data.response.name,
          });
          // setloadingCrop(false);
          setUploadResponse(res.data.response);
        })
        .catch((err) => {
          setVideoUploaded(false);
        });
    }
    const handleChangeInformation = (target, object) => {
      setVideoInformation((prevState) => {
        const update = { ...prevState };
        const item = update[target];
        // console.log('update', update[target]);
        update[target] = { ...item, ...object };
        return update;
      });
    }
  return (
    <div
      className={` flex flex-col justify-start items-center w-full h-full relative ${styles.container} ${extraScrollDivStyle}`}
    >
            <Avatar
        width={100}
        height={100}
        src={userInfo?.image?.name ? userInfo?.image?.name : blanckUser}
        local={
          userInfo?.image?.name?.length != 0 &&
          userInfo?.image?.name != undefined
            ? false
            : true
        }

      />
     {(userInfo?.username || userInfo?.channelName) && (
        <p>
          {userInfo?.channelName ? userInfo?.channelName :userInfo?.username}
        </p>
      )}
      <div className={`${styles.menu} `}>

        {menus?.map((item, index) => (
          <>
          {item?.id==1 ? 
          <p  
          onClick={() => {
            setActiveMenu(item?.id);
          }}
          key={index}
          className={` text-center
            ${
              activeMenu == item?.id
                ? `${styles.activeMenu} mainTextColor mainBorderBottomColor`
                : styles.unActiveMenu
            } `}
          >
                  <FileUploadVideo
                  handleChange={handleChange}
                  onButtonClick={onButtonClick}
                  // handleDrag={handleDrag}
                  // handleDrop={handleDrop}
                  // dragActive={dragActive}
                  inputRef={inputRef}
                  allowedType={videoType}
                  text={item?.name}
                  buttonStyle={` mx-auto text-center
                  ${
                    activeMenu == item?.id
                      ? `${styles.activeMenu} mainTextColor `
                      : styles.unActiveMenu
                  } `}
                ></FileUploadVideo>
                </p>

        :
          <p
            onClick={() => {
              setActiveMenu(item?.id);
            }}
            key={index}
            className={` text-center
              ${
                activeMenu == item?.id
                  ? `${styles.activeMenu} mainTextColor mainBorderBottomColor`
                  : styles.unActiveMenu
              } `}
          >
            {item?.name}
          </p>
}
          </>
        ))}
      </div>
      <div
        className={`flex flex-row justify-start items-start  box-border pb-6 ${
          styles.flexStyle
        } ${themeMode == 'dark' && styles.dark} ${extraScrollDivStyleInside}`}
        id="scrollableDivFile"
        style={{ minHeight: '100%', height: '100%', overflowY: 'scroll' }}
      >
        <div
          className={`flex flex-col justify-start items-start box-border ${styles.sideWidth} w-[100%] h-[100%] px-6`}
        >
          {serverError !== '' && (
            <div className={styles.serverError}>
              <img
                src="/imgs/login/warning.svg"
                alt="warning"
                width={20}
                height={20}
                className="flex flex-row justify-center items-center"
              />
              <span>{serverError}</span>
            </div>
          )}
        </div>
        {loading ? (
          <Loader width={`w-full h-400px `} />
        ) : (
          <>
          {activeMenu==2 ?
          <InfiniteScroll
            style={{ overflowY: 'hidden', width: '100%' }}
            dataLength={files?.length}
            next={() => getMorePosts()}
            hasMore={hasMore}
            scrollThreshold={'50px'}
            loader={<Loader width={'w-full'} height={'h-[100px]'} />}
            scrollableTarget="scrollableDivFile"
          >
            {files?.length != 0 ? (
              <>
                {files?.map((item, index) => (
                  <>
                  { activeMenu != 0  ? 
                  
                  <>

                  <FileTypesContainer
                  item={item}
                  chatBody={false}
                  activePlayer={setActivePlayer}
                  activePlayerFunction={activePlayerFunction}
                  activeMessage={activeMessage}
                  setActiveMessage={setActiveMessage}
                  messages={files}
                  key={index}
                  />
           
                  </>
                  :

                  <SingleMessage key={index}  chatBody={false} item={item} content={content} favFunction={favFunction}>            <MessageTypes
                  message={item}
                  switchToShare={switchToShare}
                  content={content}
                /></SingleMessage>}
                  </>
                ))}
              </>
            ) : (
              <p className={styles.noInfoFound}>{content?.noInfoFound}</p>
            )}
          </InfiniteScroll>
          :
          <>
            {!videoUploaded  ? 
          <p>{content?.uploadVideo?.noFileUploaded}</p>
          :
          <UploadingVideoModal
          handleChangeInformation={handleChangeInformation}
          closeModal={closeModal}
          progressValue={progressValue}
          uploadResponse={uploadResponse}
          videoInformation={videoInformation}
          setVideoInformation={setVideoInformation}
          loadingCrop={loadingCrop}
          setloadingCrop={setloadingCrop}
          ifMusic={false}
          setIfMusic={setIfMusic}
          activeMenu={activeMenu}
          setActiveMenu={setActiveMenu}
          emptyVideo={emptyVideo}
          content={content?.uploadVideo}
          uploadedImage={uploadedImage}
          setUploadedImage={setUploadedImage}
          emptyUploadedImage={emptyUploadedImage}
          
        />
            }
            </>
            }
            </>
        )}
      </div>
    </div>
  );
};

export default UserDashboard;
